import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UserContextProvider } from './Hook/useUser';
import { PrefContextProvider } from './Hook/usePref';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PrefContextProvider>
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </PrefContextProvider>
  </React.StrictMode>
);